import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "./imgs/logo_header.svg";
import { Layout, Dropdown, Button } from "antd";
import "./App.css";
import { useAuth } from "./AuthProvider";
const { Header } = Layout;

const NeuroCareHeader = ({selectedMenu}) => {
  const navigate = useNavigate();
  const auth = useAuth();
  const location = useLocation()

  const handleLogout = e =>{
    auth.logOut()
  }
  const handleNavigate = (path) => {
    if(location.pathname === path){
      navigate(0)
    }else{
      navigate(path)
    }
  }

  return (
    <Header className="header-container">
      <div
        className="logo-container">
        <img
          src={logo}
          className='logo-image'
          alt="Logo"
          onClick={(e)=>{handleNavigate('/')}}
        />
      </div>
      <div className="menu-bar">
        <Button
          className={`menu-item ${
            selectedMenu == "마이페이지" ? "active-menu-item" : ""
          }`}
          onClick={() => {
            handleNavigate('/mypage')
          }}
        >
          마이페이지
        </Button>
        <Button
          className={`menu-item ${
            selectedMenu == "환자 등록" ? "active-menu-item" : ""
          }`}
          onClick={() => {
            handleNavigate('/surgery')
          }}
        >
          환자 등록
        </Button>
        <Button
          className={`menu-item ${
            selectedMenu == "검사데이터" ? "active-menu-item" : ""
          }`}
          onClick={() => {
            handleNavigate('/customer')
          }}
        >
          검사데이터
        </Button>
        <Button
          className={`menu-item ${
            selectedMenu == "분석 리포트" ? "active-menu-item" : ""
          }`}
          onClick={() => {
            handleNavigate('/report')
          }}
        >
          분석 리포트
        </Button>
        {/* <Button
          className={`menu-item ${
            selectedMenu == "cms" ? "active-menu-item" : ""
          }`}
          onClick={() => {
            navigate('/cms')
          }}
        >
          CMS
        </Button> */}
      </div>
      <div style={{width:'5%',height:'100%',display:'flex',alignItems:'center'}}>
          <button className="logout-button" onClick={handleLogout}>로그아웃</button>
      </div>
    </Header>
  );
};
export default NeuroCareHeader;
